import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { RefreshCwIcon } from "lucide-react";
import { useProjects } from "@/context/ProjectContext";
import { GetProjectResponseDto } from "@/dto/get-project-response.dto";
import { UnifiedProjectInvitation } from "@/services/projectService";

interface ResendProjectInviteDialogProps {
  project: GetProjectResponseDto;
  invitation: UnifiedProjectInvitation;
}

export function ResendProjectInviteDialog({
  project,
  invitation,
}: ResendProjectInviteDialogProps) {
  const { resendProjectInvite, resendingInvite } = useProjects();

  const handleConfirmResend = () => {
    resendProjectInvite(invitation._id, project._id);
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="outline" size="sm" disabled={resendingInvite}>
          <RefreshCwIcon className="w-4 h-4 mr-2" />
          {resendingInvite ? "Resending..." : "Resend"}
        </Button>
      </DialogTrigger>

      <DialogPortal>
        <DialogOverlay />
        <DialogContent className="max-w-md">
          <DialogTitle>Resend Invitation</DialogTitle>
          <DialogDescription>
            Are you sure you want to resend the invitation to{" "}
            <strong>{invitation.email}</strong>? This will send a new invitation
            email.
          </DialogDescription>

          <div className="flex justify-end gap-2 mt-4">
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <DialogClose asChild>
              <Button
                onClick={handleConfirmResend}
                disabled={resendingInvite}
              >
                {resendingInvite ? "Resending..." : "Confirm Resend"}
              </Button>
            </DialogClose>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
